import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import {Box, Button, CardContent, Grid} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import EditIcon from '@mui/icons-material/Edit';
import {useTranslation} from "react-i18next";
import {TemplateActions, TemplateMetadata} from "../pages/app/types.ts";

const TemplateCards = ({handleOpen, handleEdit, handleDelete, loading, tmpTemplates}: TemplateActions) => {
   const { t } = useTranslation();
    return (
        <Grid container spacing={2}>
            {tmpTemplates.length > 0 ?
                tmpTemplates.map((template: TemplateMetadata) => {
                    const {templateID, templateName, updatedAt} = template;
                    return (
                        <Grid size={{xs: 12, sm: 6, md: 4}} key={templateID}>
                            <Card sx={{flex: 1, height: '100%', borderRadius: 4}}>
                                <CardHeader
                                    title={templateName}
                                    subheader={new Date(updatedAt).toLocaleDateString()}
                                />
                                <CardContent>
                                    <Box sx={{display: 'flex', flex: 1, justifyContent: 'center', alignContent: 'center', height: '100%'}}>
                                        <Button style={{color: 'red'}} onMouseDown={event => event.stopPropagation()}
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    event.preventDefault();
                                                    handleDelete(templateID);
                                                }}>
                                            <DeleteIcon/>
                                        </Button>
                                        <Button style={{color: '#53b2ef'}} onClick={()=>handleEdit(template)}>
                                            <SettingsIcon/>
                                        </Button>
                                        <Button style={{color: '#53b2ef'}} onClick={() => handleOpen(template)}>
                                            <EditIcon/>
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    )
                })
                :
                !loading && <p>{t('dashboard.EmptyList')}</p>
            }
        </Grid>

    )

};

export default TemplateCards;
